import { RenovationType } from '../enums/offer/RenovationType';

const renovationTypeMapping: Record<RenovationType, string> = {
    [RenovationType.UNKNOWN]: '',
    [RenovationType.DESIGN]: 'Дизайнерский',
    [RenovationType.EURO]: 'Евро',
    [RenovationType.FINE]: 'Чистовая отделка',
    [RenovationType.GOOD]: 'Хороший',
    [RenovationType.NEED]: 'Нужен ремонт',
    [RenovationType.PARTIAL]: 'Частичный ремонт',
    [RenovationType.PRE_FINE]: 'С отделкой',
    [RenovationType.ROUGH]: 'Черновая отделка'
};

export { renovationTypeMapping };
